/**
 *
 * FooterWrapper
 *
 */

import React from 'react';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { makeSelectShowHomepagePro } from 'containers/Main/selectors';
import ContentBlock from 'components/ContentBlock';
import { CONTENT_BLOCK_POSITIONS } from 'components/ContentBlock/utils';
import Footer from 'components/Footer';

function FooterWrapper() {
  const showHomepagePro = useSelector(makeSelectShowHomepagePro());

  const { pathname, search } = window.location;
  const queryParams = qs.parse(search.slice(1));
  if (
    (pathname === '/' && (showHomepagePro || queryParams.showcorp === '1')) ||
    pathname === '/login' ||
    pathname === '/logincm' ||
    pathname === '/signup' ||
    pathname === '/signupcm' ||
    pathname === '/signup/data' ||
    pathname === '/signup/email' ||
    pathname === '/forgot_password'
  )
    return null;
  return (
    <>
      <ContentBlock
        type="common-page"
        marginTop={pathname === '/user-resources'}
        position={CONTENT_BLOCK_POSITIONS.ABOVE_FOOTER}
        fullWidth={pathname !== '/series'}
      />
      <Footer />
      <ContentBlock
        type="common-page"
        position={CONTENT_BLOCK_POSITIONS.BELOW_FOOTER}
        fullWidth
      />
    </>
  );
}

export default FooterWrapper;
